module.exports = __webpack_public_path__ + "static/media/IGZODisplay.85b18eb1.png";